const azarReferenceColor = {
  solidBlack: { light: '#000000', dark: '#ffffff' },
  solidWhite: { light: '#ffffff', dark: '#000000' },
  solidBlackBg: { light: '#111111', dark: '#ffffff' },
  solidWhiteBg: { light: '#ffffff', dark: '#111111' },
  solidBlackModal: { light: '#222222', dark: '#ffffff' },
  solidWhiteModal: { light: '#ffffff', dark: '#222222' },
  solidBlackFixed: '#000000',
  solidWhiteFixed: '#ffffff',
  solidBlackBgFixed: '#111111',
  solidBlackBgOpacity0: { light: '#111111', dark: '#ffffff' },
  gray30: { light: '#f8f8f8', dark: '#111111' },
  gray60: { light: '#f4f4f4', dark: '#222222' },
  gray80: { light: '#f9f9f9', dark: '#2a2a2a' },
  gray100: { light: '#eeeeee', dark: '#333333' },
  gray200: { light: '#dddddd', dark: '#444444' },
  gray300: { light: '#cccccc', dark: '#555555' },
  gray300Fixed: '#cccccc',
  gray400: { light: '#bbbbbb', dark: '#666666' },
  gray500: { light: '#aaaaaa', dark: '#888888' },
  gray600: { light: '#888888', dark: '#aaaaaa' },
  gray700: { light: '#666666', dark: '#cccccc' },
  gray800: { light: '#444444', dark: '#eeeeee' },
  gray900: { light: '#222222', dark: '#f8f8f8' },
  gray900Fixed: '#222222',
  green50: '#e5fef5',
  green100: '#b9fde4',
  green200: '#89fcd0',
  green300: '#5efcbd',
  green400: '#2efcac',
  green500: '#00f69d',
  green600: '#09d087',
  green700: '#10a971',
  green800: '#12835a',
  green850: '#175e45',
  green900: '#1e382e',
  red50: '#fdebed',
  orange50: '#fef1ec',
  orange100: '#fde3da',
  orange200: '#fcc7b5',
  orange300: '#faac90',
  orange400: '#f9906a',
  orange500: { light: '#f87546', dark: '#ff6330' },
  orange600: '#c45e3a',
  orange700: '#90482e',
  orange800: '#5e3021',
  orange850: '#44261b',
  orange900: '#2b1a14',
  red100: '#fbd7dc',
  red200: '#f7b0b9',
  red300: '#f48996',
  red400: '#f06272',
  red500: '#ed3b50',
  red600: '#ba3242',
  red700: '#8a2733',
  red800: '#5a1b23',
  red850: '#42161c',
  red900: '#291114',
  yellow50: '#fef9e8',
  yellow100: '#fdf3d2',
  yellow200: '#fbe8a5',
  yellow300: '#f9dc78',
  yellow400: '#f7d14a',
  yellow500: '#f6c61e',
  yellow600: '#e2932c',
  yellow700: '#a45e19',
  yellow800: '#5e3210',
  yellow850: '#44240e',
  yellow900: '#2b170c',
  solidWhiteBgOpacity0: { light: '#ffffff', dark: '#111111' },
  blue50: '#ebf2fd',
  blue100: '#d7e6ff',
  blue200: '#accaff',
  blue300: '#80b3ff',
  blue400: '#589aff',
  blue500: '#3082ff',
  blue600: '#3566bb',
  blue700: '#294d8b',
  blue800: '#1e3459',
  blue850: '#182742',
  blue900: '#121b29',
  indigo50: '#edeefc',
  indigo100: '#dcddfa',
  indigo200: '#b9bbf6',
  indigo300: '#9799f1',
  indigo400: '#7477ed',
  indigo500: '#5256e9',
  indigo600: '#4447b7',
  indigo700: '#353687',
  indigo800: '#252758',
  indigo850: '#1f1e3f',
  indigo900: '#161728',
  solidBlackModalOpacity0: { light: '#222222', dark: '#ffffff' },
  solidWhiteModalOpacity0: { light: '#ffffff', dark: '#222222' },
  purple50: '#f4edfd',
  purple100: '#e9dbfb',
  purple200: '#d4b7f7',
  purple300: '#bf93f4',
  purple400: '#aa6ef0',
  purple500: '#954bed',
  purple600: '#773ebb',
  purple700: '#59318a',
  pink50: '#feedf3',
  cyan50: '#d4fcff',
  cyan100: '#aaf9ff',
  cyan200: '#80f7ff',
  cyan300: '#55f4ff',
  cyan400: '#2bf1ff',
  cyan500: '#00eeff',
  cyan600: '#00c6d4',
  cyan700: '#009faa',
  cyan800: '#007780',
  cyan850: '#004f55',
  cyan900: '#00282b',
  lime50: '#fbffd4',
  iris50: '#d0e2fe',
  iris100: '#b5caff',
  iris200: '#99b1ff',
  iris300: '#8299ff',
  iris400: '#6e83ff',
  iris500: '#5667ff',
  iris600: '#4b5cf2',
  iris700: '#454fde',
  iris800: '#3f3fc2',
  iris850: '#342f93',
  iris900: '#2a2577',
  lime100: '#f7ffaa',
  lime200: '#f3ff80',
  lime300: '#f0ff55',
  lime400: '#ecff2b',
  lime500: '#e8ff00',
  lime600: '#c1d400',
  lime700: '#9baa00',
  lime800: '#748000',
  lime850: '#4d5500',
  lime900: '#272b00',
  facebook1: '#1877f2',
  facebook2: '#015fd9',
  snapchat1: '#fffc00',
  snapchat2: '#d9d600',
  qq1: '#3ebdf9',
  qq2: '#38a2d3',
  kakao1: '#ffeb00',
  kakao2: '#e6d019',
  line1: '#04bb00',
  line2: '#238421',
  twitter1: '#1da1f2',
  twitter2: '#1989ce',
  x1: '#111111',
  x2: '#000000',
  pink100: '#fddce8',
  pink200: '#fbbad1',
  pink300: '#f998bb',
  pink400: '#f776a4',
  pink500: '#f5548e',
  pink600: '#c14672',
  pink700: '#8f3656',
  pink800: '#5d2639',
  pink850: '#431f2c',
  pink900: '#2b161e',
  purple800: '#3b2359',
  purple850: '#2d1b42',
  purple900: '#1e1529',
} as const;

export default azarReferenceColor;
